/* ===== 이미지/영상 배너 (custom-image-banner.liquid) 동작 스크립트 ===== */
(function () {
  'use strict';

  function initBanner(section) {
    /* PC/모바일 이미지 전환은 <picture><source media="..."></picture>가 브라우저
       차원에서 처리하므로(더 안정적) 별도의 자바스크립트가 필요 없다. */

    /* 1) 헤더(GNB) 오버랩 처리 ------------------------------------------- */
    if (section.getAttribute('data-header-overlay') === 'true') {
      var selector = section.getAttribute('data-header-selector') || 'header';
      var headerEl = document.querySelector(selector);
      if (headerEl) {
        var setHeaderVar = function () {
          section.style.setProperty('--header-h', headerEl.offsetHeight + 'px');
        };
        setHeaderVar();
        window.addEventListener('resize', setHeaderVar);
        section.classList.add('is-header-overlay');
        headerEl.classList.add('ib-header--overlay');
      } else if (window.console) {
        console.warn('[image-banner] header_selector("' + selector + '")에 해당하는 요소를 찾지 못했습니다. 테마 헤더 구조에 맞게 설정을 수정하세요.');
      }
    }

    /* 2) 텍스트/버튼 등장 애니메이션 (스크롤 진입 시 1회) ------------------- */
    var animated = section.querySelectorAll('.ib__el[class*="ib__anim--"]');
    if ('IntersectionObserver' in window && animated.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2 });
      animated.forEach(function (el) { io.observe(el); });
    } else {
      animated.forEach(function (el) { el.classList.add('is-visible'); });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-image-banner]').forEach(initBanner);
  }

  /* 테마 편집기(Design Mode) 대응: 설정을 바꿔 섹션이 다시 로드될 때 재초기화 */
  document.addEventListener('DOMContentLoaded', initAll);
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('[data-image-banner]');
      if (el) initBanner(el);
    });
  }
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    initAll();
  }
})();